import { render, staticRenderFns } from "./index(backup).vue?vue&type=template&id=bc1f80ca&scoped=true&"
import script from "./index(backup).vue?vue&type=script&lang=js&"
export * from "./index(backup).vue?vue&type=script&lang=js&"
import style0 from "./index(backup).vue?vue&type=style&index=0&id=bc1f80ca&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1f80ca",
  null
  
)

export default component.exports